import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SettingsContext = createContext(null);

const FALLBACK = {
  hero_title: "Türkiye'nin Her Noktasına Taze Midye",
  hero_subtitle: "Çiftliğimizden sofranıza, soğuk zincir ile.",
  hero_image_url: "https://images.pexels.com/photos/19013341/pexels-photo-19013341.jpeg",
  hero_cta_primary_label: "Ürünleri İncele",
  hero_cta_secondary_label: "Hemen Sipariş Ver",
  features: [],
  contact_phone: "",
  contact_whatsapp: "",
  contact_email: "",
  contact_address: "",
  about_title: "",
  about_content: "",
  about_image_url: "",
  footer_description: "",
  bus_fee: 400,
};

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);
  const [otogars, setOtogars] = useState([]);

  const reload = async () => {
    try {
      const [s, o] = await Promise.all([api.get("/settings"), api.get("/otogars")]);
      setSettings(s.data);
      setOtogars(o.data);
    } catch {}
  };

  useEffect(() => { reload(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, otogars, reload }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext) || { settings: FALLBACK, otogars: [], reload: () => {} };
